import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'index',
    redirect: '/cloud',
  }, {
    path: '/authorize',
    name: 'authorize',
    component: () => import('../views/authorize.vue'),
  }, {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/logout.vue'),
  }, {
    path: '/login',
    name: 'login',
    component: () => import('../views/login'),
  }, {
    path: '/find-pwd',
    name: 'findPwd',
    component: () => import('../views/find-pwd.vue'),
  }, {
    path: '/cloud',
    name: 'cloud',
    component: () => import('../views/home.vue'),
  }, {
    path: '/user',
    name: 'user',
    component: () => import('../views/user/index.vue'),
    children: [
      {
        path: '/user/base-info',
        name: 'base-info',
        component: () => import('../views/user/base-info/index.vue'),
      },
      {
        path: '/user/safe',
        name: 'safe',
        component: () => import('../views/user/safe/index.vue'),
        children: [
          {
            path: '/user/safe/list',
            name: 'safe-list',
            component: () => import('../views/user/safe/list.vue'),
          },
          {
            path: '/user/safe/edit-mobile',
            name: 'safe-edit-mobile',
            component: () => import('../views/user/safe/edit-mobile/index.vue'),
          },
          {
            path: '/user/safe/edit-password',
            name: 'safe-edit-password',
            component: () => import('../views/user/safe/edit-password/index.vue'),
          },
        ],
      },
      {
        path: '/user/default-corp',
        name: 'default-corp',
        component: () => import('../views/user/default-corp/index.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
